
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import { FreeTextOptions } from "@/model/pagePartOptions/FreeTextOptions";
    import { VisitAnswer } from "@/model/VisitAnswer";

    @Component({})
    export default class FreeTextsPart extends Vue {

        @Prop({ default: new FreeTextOptions() })
        options!: FreeTextOptions;

        @Prop({ required: true })
        answer!: VisitAnswer;

        @Prop({ default: false })
        isAdminView!: boolean;

        // onTextAreaInput(event: Event) {
        //     console.log("FREETEXT - onTextAreaInput event = ", typeof event);
        // }

        onTextAreaInput(text: string) {
            //console.log("FREETEXT - onTextAreaInput = ", text);
            this.$emit("answer-changed", -1, this.answer.pagePartID, text);
        }
    }
